var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._b({tag:"component",staticClass:"danger-button",class:_vm.class_list,on:{"click":function($event){return _vm.$emit('click', $event)}}},'component',_vm.component_attr,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }